import { render, staticRenderFns } from "./dialog-create-from-template.vue?vue&type=template&id=0a6edf5b&scoped=true&"
import script from "./dialog-create-from-template.vue?vue&type=script&lang=ts&"
export * from "./dialog-create-from-template.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-create-from-template.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./dialog-create-from-template.vue?vue&type=style&index=1&id=0a6edf5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6edf5b",
  null
  
)

export default component.exports